exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".p-invoices .b-table{min-width:1380px}.p-invoices .b-table td,.p-invoices .b-table th{font-size:.75rem}", ""]);

// exports
